document.addEventListener('click', function (event) {
  const trigger = event.target.closest('[data-price-promise-open]');
  const closeButton = event.target.closest('[data-price-promise-close]');

  if (trigger) {
    event.preventDefault();

    const modalId = trigger.getAttribute('data-price-promise-open');

    const modal = modalId
      ? document.getElementById(modalId)
      : document.querySelector('dialog[id^="PricePromiseModal-"]');

    if (modal && typeof modal.showModal === 'function') {
      modal.showModal();
    }
  }

  if (closeButton) {
    const modal = closeButton.closest('dialog');

    if (modal) {
      modal.close();
    }
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('[data-price-promise-form]');

  if (!form) return;

  const successMessage = form.querySelector(
  '.price-promise-form__confirmation'
);

  const errorMessage = form.querySelector(
    '.price-promise-form__message--error'
  );

  const formFields = form.querySelector(
    '[data-price-promise-fields]'
  );

  const submitButton = form.querySelector(
    '[type="submit"]'
  );

  if (
    !successMessage ||
    !errorMessage ||
    !formFields ||
    !submitButton
  ) {
    console.error('Price Promise form elements could not be found.');
    return;
  }

  const originalButtonText = submitButton.textContent.trim();

  form.addEventListener('submit', async (event) => {
    event.preventDefault();

    successMessage.style.display = 'none';
    errorMessage.style.display = 'none';

    submitButton.disabled = true;
    submitButton.textContent = 'Sending…';

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: {
          Accept: 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`Submission failed: ${response.status}`);
      }

      form.reset();

formFields.classList.add('is-hiding');

window.setTimeout(() => {
  formFields.style.display = 'none';

  successMessage.style.display = 'block';

  requestAnimationFrame(() => {
    successMessage.classList.add('is-visible');
  });

  successMessage.scrollIntoView({
    behavior: 'smooth',
    block: 'nearest'
  });
}, 300);
    } catch (error) {
      console.error('Price Promise submission failed:', error);
      errorMessage.style.display = 'block';
    } finally {
      submitButton.disabled = false;
      submitButton.textContent = originalButtonText;
    }
  });
});